import React, { useContext, useEffect } from 'react'
import { Outlet, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from '../UserContext';
import Cookies from 'universal-cookie';
import { jwtDecode } from "jwt-decode"; // Import jwt-decode

const cookies = new Cookies();
const SESSION_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export default function Protected() {
    const {user,setUser, token, setToken, setRefreshToken, sessionStartedAt, setSessionStartedAt, forceRefreshToken}=useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();
    const fromPath = `${location.pathname}${location.search}`;

    const isSessionExpired = (() => {
      if (!token) return false;
      if (!sessionStartedAt) return false;
      const startedAtMs = new Date(sessionStartedAt).getTime();
      if (Number.isNaN(startedAtMs)) return false;
      return Date.now() - startedAtMs > SESSION_MAX_AGE_MS;
    })();

    const clearAuth = () => {
      setUser(null);
      setToken('');
      setRefreshToken('');
      setSessionStartedAt('');

      cookies.remove('user', { path: '/' });
      cookies.remove('token', { path: '/' });
      cookies.remove('refreshToken', { path: '/' });
      cookies.remove('sessionStartedAt', { path: '/' });
    };

    useEffect(() => {
      const refresh = async () => {
        try {
          await forceRefreshToken();
        } catch (error) {
          console.error(error);
          clearAuth();
          navigate('/login', { replace: true, state: { from: fromPath } });
        }
      };
  
      if (user && token) {
        const tokenExp = new Date(jwtDecode(token).exp * 1000);
        const now = new Date();
  
        // Refresh token if it's about to expire
        if (tokenExp - now < 60 * 1000) {
          refresh();
        }
      }
    }, [user, token, forceRefreshToken, fromPath]);

    useEffect(() => {
      if (!token) return;

      if (!sessionStartedAt) {
        setSessionStartedAt(new Date().toISOString());
        return;
      }

      const startedAtMs = new Date(sessionStartedAt).getTime();
      if (Number.isNaN(startedAtMs)) {
        setSessionStartedAt(new Date().toISOString());
        return;
      }

      if (Date.now() - startedAtMs > SESSION_MAX_AGE_MS) {
        clearAuth();
        navigate('/login', { replace: true, state: { from: fromPath } });
      }
    }, [token, sessionStartedAt, fromPath]);

    //Only allow the user further if token exists
  return (
    token && !isSessionExpired ? <Outlet/> : <Navigate to='/login' replace state={{ from: fromPath }} />
  )
}
